import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { Form, Grid } from "semantic-ui-react";
import QuestionSet from "../components/QuestionSet";
import { BasicLoadingState, ConditionalFileProps } from "../State";
import { store, handleSubmit } from "../store";

const SpecialCallsQuestionnaire: React.FunctionComponent = () => {
    const [state, setState] = useState<BasicLoadingState>({ isLoading: false });

    const globalState = useContext(store);

    return (
        !(globalState.state.appState.user && globalState.state.appState.user.profile.role_extended.includes("Cafe:carrier")) && <Redirect to={"/"} /> ||
        <Grid centered className="QuestionSetContainer">
            <Form size={"small"} method="post" action="/Index" encType="multipart/form-data">
                {
                    <QuestionSet isLoading={state.isLoading} icon={state.icon}
                        onSubmit={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSubmit({ state, setState },
                            globalState.state, e, "VSC",
                            (formData: FormData) => {
                                let files0012 = globalState.state.answerState![5].answerValue as ConditionalFileProps;
                                let files0942 = globalState.state.answerState![4].answerValue as ConditionalFileProps;
                                let files9887 = globalState.state.answerState![3].answerValue as ConditionalFileProps;
                                formData.append("FileName0012", files0012.files != null && files0012.files.length > 0 ? files0012.files[0].name : "");
                                formData.append("FileName0942", files0942.files != null && files0942.files.length > 0 ? files0942.files[0].name : "");
                                formData.append("FileName9887", files9887.files != null && files9887.files.length > 0 ? files9887.files[0].name : "");
                                formData.append("Description", globalState.state.appState.user!.profile.name ? globalState.state.appState.user!.profile.name : "");
                            }
                        )}
                        questionAnswers={globalState.state.answerState!} />
                }
            </Form>
        </Grid>
  );
};

export default SpecialCallsQuestionnaire;
